import { Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { updateOrderAction } from '../';
import {
    SURVEY_EXPANSION,
    SURVEY_RESPONSES_EXPANSION,
} from '../../../api/constants';
import { getOrder, getOrderAttendees } from '../../../api/order';
import { getExistingOrderId } from '../../../selectors/app';
import { CheckoutState } from '../../../state';
import { notifyParentOrderComplete } from '../../notifyParent';
import {
    getInitSurveysActionFromOrderResponse,
    prefillOrganizerQuestionsForm,
} from '../../survey';

export const getExistingOrderData =
    () =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const existingOrderId = getExistingOrderId(getState());

        if (!existingOrderId) {
            return;
        }

        try {
            const [{ response: orderResponse }, attendees] = await Promise.all([
                getOrder(existingOrderId),
                getOrderAttendees(
                    existingOrderId,
                    `${SURVEY_EXPANSION},${SURVEY_RESPONSES_EXPANSION}`,
                ),
            ]);

            const response = {
                ...orderResponse,
                attendees,
            };

            dispatch(getInitSurveysActionFromOrderResponse(response));
            dispatch(updateOrderAction(response));
            dispatch(prefillOrganizerQuestionsForm());
        } catch (error) {
            // TODO: EB-229798 - Error handling. Communicate with my order to display there the error message (postMessage)
        }
    };

export const completeOrderActions =
    (): ThunkAction<void, CheckoutState, void> => (dispatch) => {
        dispatch(notifyParentOrderComplete());
    };
